import {
  SET_LOGIN_SOURCE,
  SET_PHONE,
  SET_TOKEN,
  SET_COURSES,
  SET_COURSE_WRAPPER,
  SET_PAY_INFO,
  // SET_ORDER,
  SET_NAV_COLLAPSE,
  SET_ORDER_CONFIRM_WRAPPER,
  CLEAR_ORDER_CONFIRM_WRAPPER
} from './mutation-types'

// //1.引入vue
// import Vue from 'vue'
// //2.新创建一个vue实例
// let vue = new Vue()

export default {


  setCourses({commit}, {courses}) {
    commit(SET_COURSES, {courses})
  },

  setCourseWrapper({commit}, {courseWrapper}) {
    commit(SET_COURSE_WRAPPER, {courseWrapper})
  },

  setPayInfo({commit}, {payInfo}) {
    commit(SET_PAY_INFO, {payInfo})
  },

  // setOrder({commit}, {order}) {
  //   commit(SET_ORDER, {order})
  // },

  setOrderConfirmWrapper({commit}, {orderConfirmWrapper}) {
    commit(SET_ORDER_CONFIRM_WRAPPER, {orderConfirmWrapper})
  },

  cleanOrderConfirmWrapper({commit}) {
    commit(CLEAR_ORDER_CONFIRM_WRAPPER)
  },

  setLoginSource({commit}, {loginSource}) {
    commit(SET_LOGIN_SOURCE, {loginSource})
  },

  setPhone({commit}, {phone}) {
    commit(SET_PHONE, {phone})
  },

  setNavCollapse({commit}, {navCollapse}) {
    commit(SET_NAV_COLLAPSE, {navCollapse})
  },

  setToken({commit}, {token}) {
    commit(SET_TOKEN, {token})
  },

}



// WEBPACK FOOTER //
// ./src/store/actions.js